module.exports = __webpack_public_path__ + "img/reminder_ferie_emt.3f26f255.png";